import { WeatherImpactActionTypes } from './constants';

export const INIT_STATE = {
    errorGetSummary: null,
    loadingSummary: false,
    summary: null,
    errorGetEventMix: null,
    loadingEventMix: false,
    eventMix: [],
    errorGetCarrierPerformance: null,
    loadingCarrierPerformance: false,
    carrierPerformance: [],
    errorGetShipmentReport: null,
    loadingShipmentReport: false,
    shipmentReport: [],
    errorGetWarehouseImpact: null,
    loadingWarehouseImpact: false,
    warehouseImpact: [],
    errorGetEventSummary: null,
    loadingEventSummary: false,
    eventSummary: [],
    errorGetMap: null,
    loadingMap: false,
    mapPoints: [],
};

type WeatherImpactAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    errorGetSummary?: null,
    loadingSummary: Boolean,
    summary: any,
    errorGetEventMix?: null,
    loadingEventMix: Boolean,
    eventMix: any,
    errorGetCarrierPerformance?: null,
    loadingCarrierPerformance: Boolean,
    carrierPerformance: any,
    errorGetShipmentReport?: null,
    loadingShipmentReport: Boolean,
    shipmentReport: any,
    errorGetWarehouseImpact?: null,
    loadingWarehouseImpact: Boolean,
    warehouseImpact: any,
    errorGetEventSummary?: null,
    loadingEventSummary: Boolean,
    eventSummary: any,
    errorGetMap?: null,
    loadingMap: Boolean,
    mapPoints: any,
};

const WeatherImpact = (state: State = INIT_STATE, action: WeatherImpactAction): any => {
    switch (action.type) {
        case WeatherImpactActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case WeatherImpactActionTypes.GET_SUMMARY_REQUEST:
                    return { ...state, loadingSummary: false, summary: action.payload.data };
                case WeatherImpactActionTypes.GET_EVENT_MIX_REQUEST:
                    return { ...state, loadingEventMix: false, eventMix: action.payload.data || [] };
                case WeatherImpactActionTypes.GET_CARRIER_PERFORMANCE_REQUEST:
                    return { ...state, loadingCarrierPerformance: false, carrierPerformance: action.payload.data || [] };
                case WeatherImpactActionTypes.GET_SHIPMENT_REPORT_REQUEST:
                    return { ...state, loadingShipmentReport: false, shipmentReport: action.payload.data || [] };
                case WeatherImpactActionTypes.GET_WAREHOUSE_IMPACT_REQUEST:
                    return { ...state, loadingWarehouseImpact: false, warehouseImpact: action.payload.data || [] };
                case WeatherImpactActionTypes.GET_EVENT_SUMMARY_REQUEST:
                    return { ...state, loadingEventSummary: false, eventSummary: action.payload.data || [] };
                case WeatherImpactActionTypes.GET_MAP_REQUEST:
                    return { ...state, loadingMap: false, mapPoints: action.payload.data || [] };
                default:
                    return { ...state };
            }

        case WeatherImpactActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case WeatherImpactActionTypes.GET_SUMMARY_REQUEST:
                    return { ...state, loadingSummary: false, errorGetSummary: action.payload.error };
                case WeatherImpactActionTypes.GET_EVENT_MIX_REQUEST:
                    return { ...state, loadingEventMix: false, errorGetEventMix: action.payload.error };
                case WeatherImpactActionTypes.GET_CARRIER_PERFORMANCE_REQUEST:
                    return { ...state, loadingCarrierPerformance: false, errorGetCarrierPerformance: action.payload.error };
                case WeatherImpactActionTypes.GET_SHIPMENT_REPORT_REQUEST:
                    return { ...state, loadingShipmentReport: false, errorGetShipmentReport: action.payload.error };
                case WeatherImpactActionTypes.GET_WAREHOUSE_IMPACT_REQUEST:
                    return { ...state, loadingWarehouseImpact: false, errorGetWarehouseImpact: action.payload.error };
                case WeatherImpactActionTypes.GET_EVENT_SUMMARY_REQUEST:
                    return { ...state, loadingEventSummary: false, errorGetEventSummary: action.payload.error };
                case WeatherImpactActionTypes.GET_MAP_REQUEST:
                    return { ...state, loadingMap: false, errorGetMap: action.payload.error };
                default:
                    return { ...state };
            }

        case WeatherImpactActionTypes.GET_SUMMARY_REQUEST:
            return { ...state, loadingSummary: true, summary: null };
        case WeatherImpactActionTypes.GET_EVENT_MIX_REQUEST:
            return { ...state, loadingEventMix: true, eventMix: [] };
        case WeatherImpactActionTypes.GET_CARRIER_PERFORMANCE_REQUEST:
            return { ...state, loadingCarrierPerformance: true, carrierPerformance: [] };
        case WeatherImpactActionTypes.GET_SHIPMENT_REPORT_REQUEST:
            return { ...state, loadingShipmentReport: true, shipmentReport: [] };
        case WeatherImpactActionTypes.GET_WAREHOUSE_IMPACT_REQUEST:
            return { ...state, loadingWarehouseImpact: true, warehouseImpact: [] };
        case WeatherImpactActionTypes.GET_EVENT_SUMMARY_REQUEST:
            return { ...state, loadingEventSummary: true, eventSummary: [] };
        case WeatherImpactActionTypes.GET_MAP_REQUEST:
            return { ...state, loadingMap: true, mapPoints: [] };
        default:
            return { ...state };
    }
};

export default WeatherImpact;
